(ns app.front.view.project.subs
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [core.db.entity.util :as eu]
            [re-frame.core-instrumented :as rf]))

(defn child-entity-sub-signal-fn [parent-id-sub]
  (fn [[_ grandparent-id]]
    [(rf/subscribe [::entities/entity-db])
     (rf/subscribe [parent-id-sub grandparent-id])]))

(defn child-entity-sub-fn [entity-type-or-types]
  (let [entity-types (if (coll? entity-type-or-types)
                       entity-type-or-types
                       (vector entity-type-or-types))]
    (fn [[entity-db parent-id-or-ids] _]
      (let [parent-ids (if (set? parent-id-or-ids)
                         parent-id-or-ids
                         (hash-set parent-id-or-ids))]
        (->> entity-db
             vals
             (filter (comp parent-ids :entity/parent))
             (filter (apply eu/is-type-fn entity-types))
             du/entity-id-set)))))

(defn sub-has-ids? [ids _]
  (-> ids seq boolean))

(rf/reg-sub ::project-workspace-ids
  :<- [::entities/entity-db]
  (fn [entity-db [_ grandparent-id]]
    (->> entity-db
         vals
         (filter #(-> % :entity/parent (= grandparent-id)))
         (filter (eu/is-type-fn :entity.type/workspace))
         du/entity-id-set)))
